import ApiKeysStore from './keys/state/ApiKeysStore';
import EmpresasStore from './empresas/state/EmpresasStore';
import SucursalStore from './sucursal/state/SucursalStore';
import EmailValidationStore from './configuracion/state/EmailValidationStore';
import EmailVerificationStore from './configuracion/state/EmailVerificationStore';
import HistorialCompraListStore from './historial-compras/state/HistorialCompraListStore';
import HistorialCompraInfoStore from './historial-compras/state/HistorialCompraInfoStore';
import ConfiguracionHitsBalanceStore from './preferencias/state/ConfiguracionHitsBalanceStore';

const CuentaStore = {
  configuracion: {
    validation: EmailValidationStore,
    verification: EmailVerificationStore,
  },
  empresas: EmpresasStore,
  apikeys: ApiKeysStore,
  hits: {
    balance: ConfiguracionHitsBalanceStore,
  },
  historial_compra: {
    list: HistorialCompraListStore,
    info: HistorialCompraInfoStore,
  },
  sucursal: SucursalStore,
};

export default CuentaStore;
